/**
 * Checks if a string is a valid http or https URL.
 * Safe to call during SSR since we avoid browser-only APIs.
 *
 * Tool and model output is untrusted, so callers use this to fail closed and
 * reject unsafe schemes such as `javascript:` or `data:` before exposing a
 * value as an `href`.
 */
export function isValidHttpUrl(url: string): boolean {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return false
  }
  try {
    // The URL is guaranteed to be absolute (http/https prefix checked above),
    // so no base is required. eslint-disable is needed because the rule
    // requires window.location.origin as base, but window is not available in SSR.
    // eslint-disable-next-line no-restricted-syntax
    const parsed = new URL(url)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}
